import Vue from 'vue';
import { getPlatform } from '@king-fisher/mobileweb-lib';

// 已添加监听股票列表
const stocks: string[] = [];

// 响应式股票行情数据
let reactiveStocks = {};

let hasRegister = false;
let HQConnectionDebounceTimer;

function webJSHandlerfnDone(fnName: any, cb: any) {
  if (typeof window.WebViewJavascriptBridge == 'object') {
    typeof window.WebViewJavascriptBridge[fnName] == 'function' && cb(window.WebViewJavascriptBridge[fnName]);
  } else {
    document.addEventListener(
      'WebViewJavascriptBridge',
      function () {
        typeof window.WebViewJavascriptBridge[fnName] == 'function' &&
          cb(window.WebViewJavascriptBridge[fnName]);
      },
      false
    );
  }
}

function callOnlineHandler(action: any, id: any, param: any) {
  let cbId = id;
  if (!cbId) {
    cbId = 'theOne';
  }
  webJSHandlerfnDone('callOnlineHandler', function (cb: any) {
    cb(action, cbId, param);
  });
}

function clearOnlineHandler(id: any) {
  if (!id && typeof id !== 'number') {
    return;
  }
  webJSHandlerfnDone('clearOnlineHandler', function (cb: any) {
    cb(id);
  });
}
//通知客户端关闭行情
function disConnectHQ(callback: any) {
  if (getPlatform() == 'gphone') {
    clearOnlineHandler(['theOne']);
    // eslint-disable-next-line thsjs/no-redundant-assignments
    hasRegister = false;
    // hasRegister && ();
    typeof callback == 'function' && callback();
  } else {
    window.callNativeHandler(
      'getHQ',
      {
        method: 'disconnect',
      },
      function () {
        // eslint-disable-next-line thsjs/no-redundant-assignments
        hasRegister = false;
        typeof callback == 'function' && callback();
      }
    );
  }
}

function mockConnection(param: any, cb: any) {
  const price = param.stockList.map(() => parseFloat((Math.random() * 100).toFixed(2)));
  const chg = param.stockList.map(() => parseFloat((Math.random() * 10 - 5).toFixed(2)));
  cb &&
    cb({
      10: price,
      34818: chg,
    });
}

function gphoneRegisterConnection(param: any, cb: any, isOnce: any) {
  const columnOrderStr = param.columOrder.join('|');
  const stockStr = param.stockList.join('|');
  const marketStr = param.marketList.join('|');

  const ajaxParam = {
    protocolId: isOnce ? '1264' : '1201',
    pageId: '9001',
    requestDic: `startrow=0\r\nrowcount=${
      param.stockList.length
    }\r\nsortid=-1\r\ncolumnorder=${columnOrderStr}\r\nnewrealtime=${
      isOnce ? '1' : '0'
    }\r\nselfstockcustom=1\r\nstocklist=${stockStr}\r\nmarketlist=${marketStr}`,
  };
  const ajaxParamStr = JSON.stringify(ajaxParam);
  const onceFn = function (data: any) {
    if (data.body && data.body.dataDict) {
      const nativeData = JSON.parse(data.body.dataDict);
      typeof cb === 'function' && cb(nativeData);
    }
  };
  if (isOnce) {
    window.callNativeHandler('UnifiedRequestBridge', ajaxParamStr, onceFn);
  } else {
    window.registerWebHandler('UnifiedRequestBridge', onceFn);
    callOnlineHandler('UnifiedRequestBridge', 'theOne', ajaxParamStr);
  }
}

function iphoneRegisterConnection(param: any, cb: any, isOnce: any) {
  //注册事件
  window.callNativeHandler('getHQ', {
    columnorder: param.columOrder, // 现价 涨跌幅 涨跌额
    stocklist: param.stockList, //股票代码列表
    marketlist: param.marketList, //市场id类别
  });

  //注册获取行情
  window.registerWebHandler('getHQ', function (data: any) {
    if (data.method == 'normal' && data.data) {
      // eslint-disable-next-line no-param-reassign
      const hqData = data.data;
      typeof cb == 'function' && cb(hqData);
      if (isOnce) {
        disConnectHQ(() => false);
      }
    }
  });
}

//实时请求股票行情数据
function registerWebHandlerForStock(param: any, cb: any, type?: string) {
  // MOCK
  if (!window.getAppVersion()) {
    //注册事件
    mockConnection(param, cb);
  }

  const isOnce = type === 'once';

  if (!hasRegister) {
    //未注册
    hasRegister = true;
    if (getPlatform() == 'gphone') {
      gphoneRegisterConnection(param, cb, isOnce);
    } else {
      iphoneRegisterConnection(param, cb, isOnce);
    }
  } else {
    //已注册
    disConnectHQ(function () {
      registerWebHandlerForStock(param, cb);
    });
  }
}
/**
 * 与客户端建立行情数据连接
 * @param {Array<{id: string; price: string; chg: string; closePrice: string;}>} stocks
 */
function openHQDataConnection(stocksList: any) {
  // [现价, 涨幅]
  const columOrder = ['10', '34818'];
  const stockList = [];
  const marketList = [];
  for (const code of stocksList) {
    const { id } = reactiveStocks[code];
    stockList.push(code);
    marketList.push(id);
  }
  disConnectHQ(() => false);
  registerWebHandlerForStock(
    {
      columOrder,
      stockList,
      marketList,
    },
    function (HQRes: any) {
      const { '10': price, '34818': chg } = HQRes;
      for (let i = 0; i < stockList.length; i++) {
        const stockCode = stockList[i];
        const curStockData = reactiveStocks[stockCode] || {};
        Vue.set(reactiveStocks, stockCode, {
          id: curStockData.id,
          price: price[i],
          chg: chg[i],
        });
      }
    }
  );
}
/**
 * 添加行情股票订阅
 * @param {string | number} stockCode
 * @param {string | number} marketId
 */
function addStockSub(stockCode: any, marketId: any) {
  const code = `${stockCode}`;
  const id = `${marketId}`;
  if (stocks.indexOf(code) > -1 || !code) {
    return false;
  }
  stocks.push(code);
  // 初始化行情数据
  Vue.set(reactiveStocks, code, {
    id,
    price: '--', // 现价
    chg: '--', // 涨幅
  });
  if (HQConnectionDebounceTimer) {
    clearTimeout(HQConnectionDebounceTimer);
  }
  HQConnectionDebounceTimer = setTimeout(openHQDataConnection.bind(null, stocks), 500);
  return true;
}
/**
 * 注册 Vue 全局属性 $hqData
 * @param {any} Vue
 */
export default function HQObserver() {
  reactiveStocks = Vue.observable(reactiveStocks);
  Vue.prototype.$hqData = reactiveStocks;
  Vue.prototype.$hqData.addStockSub = addStockSub;
}
